import { useId, type InputHTMLAttributes } from 'react';
import styles from './Field.module.css';

interface FieldProps extends InputHTMLAttributes<HTMLInputElement> {
  label: string;
  hint?: string;
  inputClassName?: string;
}

/** A labelled text input with an optional hint below it. */
export function Field({ label, hint, inputClassName, ...inputProps }: FieldProps) {
  const hintId = useId();
  return (
    <label className={styles.field}>
      <span className={styles.label}>{label}</span>
      <input
        className={[styles.input, inputClassName].filter(Boolean).join(' ')}
        aria-describedby={hint ? hintId : undefined}
        {...inputProps}
      />
      {hint && (
        <span id={hintId} className={styles.hint}>
          {hint}
        </span>
      )}
    </label>
  );
}

/** A form-level error message, announced to screen readers. */
export function FormError({ message }: { message: string | null }) {
  return message ? (
    <p className={styles.error} role="alert">
      {message}
    </p>
  ) : null;
}
